import React, { useState } from "react";
import { FaExclamationTriangle } from "react-icons/fa";
import { FaSortUp } from "react-icons/fa6";
import { HiDotsVertical } from "react-icons/hi";
import { MdEditSquare } from "react-icons/md";
import client from "../../assets/img/user/user1.png";
import SlideProgress from "../Progress/SlideProgress";
import CreditScore from "../chart/CreditScore";
import FileUploader from "../fileUploader/FileUploader";
import InputField from "../inputField/InputField";
import PasswordInput from "../inputField/PasswordInput";
import CustomSelector from "../selector/CustomSelector";

export default function ClientProfile() {
  const [name, setName] = useState("");
  const [pass, setPass] = useState("");

  const cardData = [
    {
      title: "Experian",
      number: "590",
      dis_number: "200",
      pts: "15 pts",
      status: "Just updated",
      pts_icons: <FaSortUp />,
    },
    {
      title: "Equifax",
      number: "590",
      dis_number: "200",
      pts: "13 pts",
      status: "Just updated",
      pts_icons: <FaSortUp />,
    },
    {
      title: "TransUnion",
      number: "590",
      dis_number: "200",
      pts: "15 pts",
      status: "Just updated",
      pts_icons: <FaSortUp />,
    },
  ];

  const disputes = [
    { name: "Experian", count: 10 },
    { name: "Equifax", count: 10 },
    { name: "TransUnion", count: 10 },
  ];

  const options = [
    { value: "24h", label: "24 Hours" },
    { value: "7d", label: "7 Days" },
    { value: "30d", label: "30 Days" },
    { value: "1y", label: "1 Year" },
    { value: "all", label: "All Time" },
  ];

  const totalDisputes = disputes.reduce((total, item) => total + item.count, 0);

  const handleNameChange = (event) => {
    setName(event.target.value);
  };
  const handlepassChange = (event) => {
    setPass(event.target.value);
  };

  const handleSelectChange = (option) => {
    console.log(option);
  };

  return (
    <div className="client_profile">
      <div className="client_card">
        <img className="client_img" src={client} alt="" />
        <div className="client_info">
          <h3 className="name">Adam Smith</h3>
          <p>[Credit Score: 590]</p>
          <p className="status red">Not Available for Funding</p>
        </div>
      </div>
      <div className="client_edit_info mt-3">
        <div className="edit_info">
          <p>Name: Brandon James</p>
          <p>Date of Birth: Feb 11, 1998</p>
          <p>Age: 26</p>
        </div>
        <MdEditSquare className="icons" />
      </div>
      <div className="row mt-4">
        <div className="col-lg-6">
          <div className="analytical_card_list">
            {cardData.map((cardData, index) => (
              <div className="card">
                <p className="sub-title">{cardData.title}</p>
                <div className="card-body">
                  <div className="number_area">
                    <h1 className="number mt-2">
                      {cardData.number}
                      <span className="dis-number">{cardData.dis_number}</span>
                    </h1>
                    <p className="pts">
                      {cardData.pts_icons}
                      {cardData.pts}
                    </p>
                  </div>
                  <span className="status">{cardData.status}</span>
                </div>
              </div>
            ))}
          </div>
          <div className="card mt-3 not_av_card">
            <FaExclamationTriangle className="icons red" />
            <h2>Not Available for Funding</h2>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="card">
            <div className="header_area">
              <h3>Available Borrowing Power</h3>
              <HiDotsVertical className="icons dot-icon" />
            </div>
            <h1 className="number mt-2">$75</h1>
            <div className="mt-3">
              <p className="pts">
                +6.8% <span className="status">Since last week</span>
              </p>
            </div>
          </div>
          <div className="card mt-3">
            <div className="header_area">
              <h3>Dispute Deletions</h3>
              <HiDotsVertical className="icons dot-icon" />
            </div>
            <ul className="dispute_list">
              {disputes.map((dispute, index) => (
                <li key={index}>
                  <h4>{dispute.name}</h4>
                  <h2>{dispute.count}</h2>
                </li>
              ))}
            </ul>
            <ul className="total">
              <li>
                <h3>Total:</h3>
                <h1>{totalDisputes}</h1>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="card">
            <div className="header_area">
              <h3>Credit Utilization</h3>
              <HiDotsVertical className="icons dot-icon" />
            </div>
            <SlideProgress />
          </div>
        </div>
        <div className="col-lg-12">
          <div className="card chart-box">
            <div className="header_area mb-0">
              <h3>Your Credit Score</h3>
              <HiDotsVertical className="icons dot-icon" />
            </div>
            <CreditScore />
          </div>
        </div>
        <div className="col-12">
          <div className="card">
            <div className="header_area">
              <h4>Credit Monitoring Login Details</h4>
              <MdEditSquare className="icons" />
            </div>
            <textarea name="text" id=""></textarea>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="tabs_card">
            <div className="header">
              <h4>Proof of Identity</h4>
            </div>
            <div className="content">
              <FileUploader btn_text="Browse" label="Upload file" />
            </div>
          </div>
          <div className="tabs_card">
            <div className="header">
              <h4>Proof of Address</h4>
            </div>
            <div className="content">
              <FileUploader btn_text="Browse" label="Upload file" />
            </div>
          </div>
          <div className="tabs_card">
            <div className="header">
              <h4>Additional Documents (Optional)</h4>
            </div>
            <div className="content">
              <FileUploader btn_text="Browse" label="Upload file" />
            </div>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="import_credit_report">
            <div className="card">
              <div className="header_area">
                <h4>Credit Monitoring Login Details</h4>
              </div>
              <div className="card_text">
                <h2>Enter Monitoring Login Details</h2>
                <p>
                  After entering the login & password, your import will begin
                  and the login details will be auto-saved to the account tab
                </p>
              </div>
              <form action="" className="input_group mt-4">
                <div className="input_group_list">
                  <div className="selector">
                    <label htmlFor="">Monitoring Agency</label>
                    <CustomSelector
                      options={options}
                      onSelect={handleSelectChange}
                    />
                  </div>
                  <InputField
                    label="Username"
                    value={name}
                    onChange={handleNameChange}
                  />
                  <PasswordInput
                    label="Password"
                    value={pass}
                    onChange={handlepassChange}
                  />
                </div>
                <button className="btn mt-4">Import Credit Report</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
